import React, { useContext, useEffect, useState } from 'react';
import "./SendOtpSms.css";
import { useTranslation } from 'react-i18next';
import { Col, Container, Form, Row } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import EmailSignatureService from '../../services/EmailSignatureService';
import { Loader } from '../../components/Loader/Loader';
import { COUNTDOWN_DURATION, FIRST_LOAD } from '../../constants/GeneralConstants';
import { isMobile } from 'react-device-detect';
import { OTP } from '../../components/SignMethods/OTP/OTP';
import { BatchContext } from '../../contexts/BatchContext';
import { Back } from '../../components/Back/Back';
import { SMSConfirmationModal } from '../../components/Modals/SMSConfirmationModal/SMSConfirmationModal';
import { ResendConfirmationModal } from '../../components/Modals/ResendConfirmationModal/ResendConfirmationModal';
import { SmsSendingIcon } from '../../components/SvgComponents/SmsSendingIcon/SmsSendingIcon';
import { ArrowIcon } from '../../components/SvgComponents/ArrowIcon/ArrowIcon';
import { AudioIcon } from '../../components/SvgComponents/AudioIcon/AudioIcon';
import { AdditionalSignaturesContext } from '../../contexts/AdditionalSignaturesContext';
import { AdditionalSignaturesFinalFlow } from '../../components/SignMethods/AdditionalSignaturesFinalFlow/AdditionalSignaturesFinalFlow';
import { SupportVerificationModal } from '../../components/Modals/SupportVerificationModal/SupportVerificationModal';
import { SmallWhatsappIcon } from '../../components/SvgComponents/SmallWhatsappIcon/SmallWhatsappIcon';
import { SmallSmsIcon } from '../../components/SvgComponents/SmallSmsIcon/SmallSmsIcon';
import { NewCodeIcon } from '../../components/SvgComponents/NewCodeIcon/NewCodeIcon';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { useOtpInput } from '../../hooks/useOtpInput';
import { useWebOtp } from '../../hooks/useWebOtp';

export const SendOtpSms = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [openModalPhoneNumberConfirmation, setOpenModalPhoneNumberConfirmation] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otpCode, setOtpCode] = useState('');
  const [emailId, setEmailId] = useState('');
  const [showOtpErrorMessage, setShowOtpErrorMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newCodeLabel, setNewCodeLabel] = useState(true);
  const [newCodeAudioLabel, setNewCodeAudioLabel] = useState(false);
  const [supportLabel, setSupportLabel] = useState(false);
  const [otpFlow, setOTPFlow] = useState(false);
  const documentsState = location.state.documents;
  const requestId = location.state.requestId;
  const documents = Array.isArray(documentsState) ? documentsState[0] : documentsState;
  const email = documents.SignerDTO.eMail;
  const selectedMethod = location.state.selectedMethod?.toLowerCase();
  const [widthIcon, setWidthIcon] = useState(150);
  const [heightIcon, setHeightIcon] = useState(147);

  const [completeAdditionalSignaturesFlow, setCompleteAdditionalSignaturesFlow] = useState(false);
  const { isSignatureBoxesFlow } = useContext(AdditionalSignaturesContext);

  const { remainingBatchDocuments, setBatchOTP, batchAttachedImages, isBatchMultisignature } = useContext(BatchContext);

  const [openModalResendConfirmation, setOpenModalResendConfirmation] = useState(false);

  const [openSupportVerificationModal, setOpenSupportVerificationModal] = useState(false);
  const [descriptionMessage, setDescriptionMessage] = useState('');
  const [showResendOption, setShowResendOption] = useState(false);
  const [countdown, setCountdown] = useState(COUNTDOWN_DURATION);
  const [isCountdownActive, setIsCountdownActive] = useState(true);
  const [resendCount, setResendCount] = useState(0);

  // On Init
  useEffect(() => {
    setPhoneNumber(location.state.phoneNumber || '');
    setEmailId(location.state.emailId);
    if (isMobile) {
      setWidthIcon(120);
      setHeightIcon(115);
    }
    const descriptionMessage = selectedMethod === 'sms' ? (t('sms.description')) : (t('sms.description_whatsapp'));
    setDescriptionMessage(descriptionMessage);
    // Avoid re-sending OTP if it was already triggered in the previous step
    if (!location.state?.otpAlreadySent) {
      sendOTPMethod();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    if (!loading) {
      // If we set disabled={true} on phone component, it doesn't show the flag
      // So we hide the select manually with this workaround, thus making the flag visible but not allowing user interaction
      const phoneSelect = document.querySelector('.PhoneInputCountrySelect');
      if (phoneSelect) phoneSelect.style.display = "none";
    }
  }, [loading]);

  // Countdown effect
  useEffect(() => {
    let interval = null;
    if (isCountdownActive && countdown > 0) {
      interval = setInterval(() => {
        setCountdown(countdown => countdown - 1);
      }, 1000);
    } else if (countdown === 0) {
      setIsCountdownActive(false);
      if (newCodeLabel) {
        if (resendCount >= 1) {
          setNewCodeLabel(false);
          setNewCodeAudioLabel(true);
          setShowResendOption(true);
        } else {
          setNewCodeAudioLabel(false);
          setShowResendOption(false);
        }
      }
    }
    return () => clearInterval(interval);
  }, [isCountdownActive, countdown, newCodeLabel, resendCount]);

  const handleShowCustomPhoneNumber = () => {
    setOpenModalPhoneNumberConfirmation(false);
  }

  const handleBack = () => {
    localStorage.setItem(FIRST_LOAD, "true");
    if (location.state?.isPhoneNumberCustom) {
      const link = '/customsms';
      navigate(link, {
        state: {
          documents,
          emailId: location.state.emailId
        }
      });
      return;
    }

    let link = '/document';
    if (documents.SignerDTO.Form && documents.SignerDTO.Form.FormDisplay.toLowerCase() === "onpreview") link = "/document-questions";

    if (isBatchMultisignature) link = '/documents';

    navigate(link, {
      state: {
        documents,
        emailId: location.state.emailId
      }
    });
  }

  const sendOTPMethod = () => {
    setLoading(true);
    if (selectedMethod === 'sms') {
      sendOtpBySMS();
      return;
    }
    sendOtpByWhatsapp();
  }

  const sendOtpBySMS = () => {
    const phoneNumber = location.state.phoneNumber;
    const body = {
      "PhoneNumber": phoneNumber
    };

    EmailSignatureService.sendOTPSms(location.state.emailId, body)
      .then((response) => {
        setLoading(false);
      })
      .catch(err => {
        const errorMessage = err?.response?.data;
        setLoading(false);
        navigate('/customsms', {
          state: {
            ...location.state,
            errorCustomSms: errorMessage,
            phoneNumber: location.state.phoneNumber
          }
        });
      });
  }

  const sendOtpByWhatsapp = () => {
    const phoneNumber = location.state.phoneNumber
    const body = {
      "PhoneNumber": phoneNumber
    };

    EmailSignatureService.sendOTPWhatsapp(location.state.emailId, body)
      .then((response) => {
        setLoading(false);
      })
      .catch(err => {
        const errorMessage = err?.response?.data;
        setLoading(false);
        navigate('/customsms', {
          state: {
            ...location.state,
            errorCustomSms: errorMessage,
            phoneNumber: location.state.phoneNumber
          }
        });
        console.log(err);
      });
  }

  const handleSendSmsCode = () => {
    setLoading(true);
    const body = {
      "OTP": otpCode
    };

    if (documents.SignerDTO.OneShot) {
      let link = "/sign";
      if (documents.SignerDTO.AttachIdDocImages && typeof attachedImages === 'undefined' && !batchAttachedImages) {
        link = "/attach-images";
      } else {
        if (isSignatureBoxesFlow) return setCompleteAdditionalSignaturesFlow(true);
      }

      navigate(link, {
        state: {
          documents,
          emailId,
          otpCode,
          requestId
        }
      });

      return;
    }
    EmailSignatureService.sendOTPCode(emailId, body)
      .then(response => {
        if (response) {
          setLoading(false);
          if (remainingBatchDocuments > 0) setBatchOTP(otpCode);

          const { SkipSigDraw } = documents.SignerDTO;

          let link = '/sign';
          if (documents.SignerDTO.AttachIdDocImages && typeof attachedImages === 'undefined' && !batchAttachedImages) {
            link = "/attach-images";
          } else {
            if (isSignatureBoxesFlow) return setCompleteAdditionalSignaturesFlow(true);
          }

          // OTP Flow
          if (SkipSigDraw && !documents.SignerDTO.AttachIdDocImages) return setOTPFlow(true);

          navigate(link, {
            state: {
              documents,
              emailId,
              otpCode,
            }
          });
          return;
        }
        setLoading(false);
        setShowOtpErrorMessage(true);
      })
      .catch(err => {
        setLoading(false);
        setShowOtpErrorMessage(true);
        console.log(err);
      });
  };

  const handlerNewCode = () => {
    setLoading(true);
    const body = { PhoneNumber: phoneNumber };

    const otpPromise =
      selectedMethod === 'whatsapp'
        ? EmailSignatureService.sendOTPWhatsapp(emailId, body)
        : EmailSignatureService.resendOtpSms(emailId, body);

    otpPromise
      .then(response => {
        setResendCount(prev => prev + 1);
        setCountdown(COUNTDOWN_DURATION);
        setIsCountdownActive(true);
        setNewCodeLabel(true);
        setNewCodeAudioLabel(false);
        setSupportLabel(false);
        setShowResendOption(false);
      })
      .catch(err => {
        setShowOtpErrorMessage(true);
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
        setOpenModalResendConfirmation(false);
      });
  };

  const handleSuccessOppositeAndAudioCallback = () => {
    setLoading(false);
    setNewCodeLabel(false);
    setNewCodeAudioLabel(false);
    setSupportLabel(true);
  };

  const requestOppositeOTPMethod = () => {
    setLoading(true);
    const body = { PhoneNumber: phoneNumber };

    const otpPromise =
      selectedMethod === 'whatsapp'
        ? EmailSignatureService.sendOTPSms(location.state.emailId, body)
        : EmailSignatureService.sendOTPWhatsapp(location.state.emailId, body);

    otpPromise
      .then(handleSuccessOppositeAndAudioCallback)
      .then(() => {
        // Update description message based on the opposite method
        const oppositeDescriptionMessage = selectedMethod === 'whatsapp' ? (t('sms.description')) : (t('sms.description_whatsapp'));

        setDescriptionMessage(oppositeDescriptionMessage);
        setShowResendOption(false);
        // Reset countdown when new code is requested
        setCountdown(COUNTDOWN_DURATION);
        setIsCountdownActive(true);
      })
      .catch(err => {
        setShowOtpErrorMessage(true);
        console.log(err);
      })
  };

  const handlerNewCodeAudio = () => {
    setLoading(true);
    const body = {
      "PhoneNumber": phoneNumber
    };
    EmailSignatureService.otpCall(location.state.emailId, body)
      .then(handleSuccessOppositeAndAudioCallback)
      .then(() => {
        // Reset countdown when new code is requested
        setCountdown(COUNTDOWN_DURATION);
        setIsCountdownActive(true);
      })
      .catch(err => {
        setShowOtpErrorMessage(true);
        setLoading(false);
        console.log(err);
      });
  };

  const handlerSupportTicket = () => {
    setLoading(true);
    navigate("/support", {
      state: {
        documents: location.state.documents,
        phoneNumber: phoneNumber,
        emailId: location.state.emailId,
        selectedMethod: selectedMethod,
      }
    });
  };

  const formatCountdown = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const handleKeyDown = (e) => {
    const otpCode = e.target.value;
    if (e.key === "Enter") {
      e.preventDefault();
      setOtpCode(otpCode);
      if (otpCode.length > 0) {
        handleSendSmsCode();
      }
    }
  };

  const otpInputProps = useOtpInput(setOtpCode);
  useWebOtp(setOtpCode, selectedMethod === 'sms');

  return (
    <>
      {loading && <Loader />}
      {completeAdditionalSignaturesFlow && <AdditionalSignaturesFinalFlow otpCode={otpCode} emailId={emailId} setLoadingMorePages={setLoading} />}
      {otpFlow && <OTP signerGuid={documents.SignerDTO.SignerGUI} otpCode={otpCode} emailId={emailId} docGuid={documents.DocGUI} email={email} setLoadingMorePages={setLoading} />}
      {!loading &&
        <Container className="document-preview-container">
          <Row>
            <Col md={12} lg={12} className="document-preview-title">
              <Back handleBack={handleBack} />
            </Col>
            <Col md={2} xs={1}></Col>
            <Col md={12} xs={10} lg={12} className="justify-content-center container-sms-box-2">
              <Row>
                <Col md={4} lg={4}>
                  <SmsSendingIcon width={widthIcon} height={heightIcon} />
                </Col>
                <Col md={8} lg={5} className="col-align">
                  <h4 className="sms-title">{t('sms.title')}</h4><br></br>
                  <p className="sms-description">{descriptionMessage}</p>
                  <Form className="phone-number-form">
                    <Form.Group className="mb-3" controlId="">
                      <PhoneInput
                        value={phoneNumber}
                        // onChange={() => {}}
                        disabled={true}
                        className="form-control phone-number-input"
                        international
                      />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="">
                      <Form.Control
                        className="phone-number-input"
                        isInvalid={`${showOtpErrorMessage ? 'error' : ''}`}
                        {...otpInputProps}
                        placeholder={t('personal_code.enter_the_code')}
                        name="otpCode"
                        value={otpCode}
                        onChange={e => setOtpCode(e.target.value)}
                        onKeyDown={handleKeyDown}
                      />
                    </Form.Group>
                  </Form>
                  {
                    showOtpErrorMessage &&
                    <div className="error-message align-error-message">
                      {t('sms.invalid_code')}
                    </div>
                  }
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={4} xs={0}></Col>
            <Col md={4} xs={12} className="button-margin button-only">
              <button type="button" className="btn btn-primary btn-active phone-number-button" disabled={otpCode.length === 0} onClick={handleSendSmsCode}>
                <span className="cancel-text">{t('general.sign')}</span>
                <ArrowIcon disabled={otpCode.length === 0} />
              </button>
            </Col>
          </Row>
          <Row>
            <Col><br></br>
              {newCodeLabel &&
                <div>
                  <h6
                    className={`new-code-label ${isCountdownActive ? 'disabled' : ''}`}
                    onClick={isCountdownActive ? undefined : () => setOpenModalResendConfirmation(true)}
                  >
                    <NewCodeIcon disabled={isCountdownActive} />
                    {isCountdownActive
                      ? `${t('sms.new_code')} ${formatCountdown(countdown)}`
                      : t('sms.request_new_code')
                    }
                  </h6>
                  {isCountdownActive && (
                    <p className="new-code-message">
                      {selectedMethod === 'sms' 
                        ? t('sms.if_no_sms_received') 
                        : t('sms.if_no_whatsapp_received')
                      }
                    </p>
                  )}
                </div>
              }
              {newCodeAudioLabel && selectedMethod !== 'whatsapp' &&
                <>
                  <div className="audio-label">
                    <span onClick={() => handlerNewCodeAudio()}>{t('sms.new_code_call')}&nbsp;&nbsp;
                      <AudioIcon />
                    </span>
                  </div>
                  {
                    showResendOption &&
                    <div className="opposite-label">
                      <span onClick={() => requestOppositeOTPMethod()}>{t('sms.option_whatsapp')}&nbsp;&nbsp;
                        <SmallWhatsappIcon width={25} height={25} />
                      </span>
                    </div>
                  }
                </>
              }
              <>
                {
                  supportLabel &&
                  <div className="support-section">
                    <p className="new-code-message">{t("sms.if_no_code_received")}</p>
                    <h6 className="new-code-label" onClick={() => setOpenSupportVerificationModal(true)}>
                      <NewCodeIcon disabled={false} />
                      {t("wizard.contact_support")}
                    </h6>
                  </div>
                }
                {
                  (showResendOption && selectedMethod === 'whatsapp') &&
                  <div className="opposite-label">
                    <span onClick={() => requestOppositeOTPMethod()}>{t('sms.option_sms')}&nbsp;&nbsp;
                      <SmallSmsIcon width={50} height={50} />
                    </span>
                  </div>
                }
              </>
            </Col>
          </Row>
          <SMSConfirmationModal openModalPhoneNumberConfirmation={openModalPhoneNumberConfirmation} setOpenModalPhoneNumberConfirmation={setOpenModalPhoneNumberConfirmation} handleShowCustomPhoneNumber={handleShowCustomPhoneNumber} phoneNumber={phoneNumber} />
          <ResendConfirmationModal openModalResendConfirmation={openModalResendConfirmation} setOpenModalResendConfirmation={setOpenModalResendConfirmation} handleResendOTP={handlerNewCode} phoneNumber={phoneNumber} />
          <SupportVerificationModal openSupportVerificationModal={openSupportVerificationModal} setOpenSupportVerificationModal={setOpenSupportVerificationModal} handlerSupportTicket={handlerSupportTicket} />
        </Container>
      }
    </>
  );
}

